import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export function initSwipers() {
  const sliders = document.querySelectorAll('.swiper-slider');

  sliders.forEach((carouselElement, i) => {
    const index = i + 1;
    const dataset = carouselElement.dataset;

    const columns = Number(dataset.columns || 1);
    const loop = dataset.loop === 'true';
    const autoplayEnabled = dataset.autoplay === 'true';
    const arrows = dataset.arrows === 'true';
    const dots = dataset.dots === 'true';
    const center = dataset.center === 'true';
    const effect = dataset.effect || 'slide';
    const margin = dataset.margin !== undefined ? Number(dataset.margin) : 30;
    const navArrowClass = dataset.arrowsClass;

    // ✅ IMPORTANT : Swiper doit être initialisé sur le vrai container
    // (celui qui contient .swiper-wrapper)
    const swiperEl =
      carouselElement.querySelector('.swiper')?.closest('.swiper') ||
      carouselElement;

    // Petite sécurité : si pas de wrapper, navigation ne marchera jamais
    if (!swiperEl.querySelector('.swiper-wrapper')) {
      console.warn('[Swiper] .swiper-wrapper introuvable pour:', swiperEl);
      return;
    }

    carouselElement.classList.add(`pbmit-element-viewtype-carousel-${index}`);

    // ---------- Responsive items ----------
    let responsiveItems;
    if (columns === 1 || columns === 1.6) responsiveItems = [columns, 1, 1, 1, 1];
    else if ([2, 2.1, 2.5].includes(columns)) responsiveItems = [columns, 2, 2, 2, 1];
    else if ([3, 3.5].includes(columns)) responsiveItems = [columns, 2, 2, 1, 1];
    else if ([4, 4.5].includes(columns)) responsiveItems = [columns, 4, 2, 2, 1];
    else if (columns === 5) responsiveItems = [5, 4, 2, 2, 1];
    else if (columns === 6) responsiveItems = [6, 4, 3, 2, 1];
    else responsiveItems = [3, 3, 2, 2, 1];

    // ---------- Pagination ----------
    let pagination = false;
    if (dots) {
      // supprime une éventuelle pagination existante (si re-init)
      carouselElement.querySelector(`.swiper-pagination-${index}`)?.remove();

      carouselElement.insertAdjacentHTML(
        'beforeend',
        `<div class="swiper-pagination swiper-pagination-${index}"></div>`
      );

      const paginationEl = carouselElement.querySelector(`.swiper-pagination-${index}`);

      pagination = carouselElement.classList.contains('pbmit-sep-number')
        ? { el: paginationEl, type: 'fraction' }
        : { el: paginationEl, clickable: true };
    }

    // ---------- Navigation ----------
    let navigation = false;
    let nextEl = null;
    let prevEl = null;

    if (arrows) {
      const container = navArrowClass
        ? document.querySelector(`.${navArrowClass}`)
        : carouselElement;

      if (!container) {
        console.warn('[Swiper] container arrowsClass introuvable:', navArrowClass);
      } else {
        // supprime d’éventuels anciens boutons pour cet index (si re-init)
        container.querySelector(`.swiper-buttons-${index}`)?.remove();

        container.insertAdjacentHTML(
          'beforeend',
          `
          <div class="swiper-buttons">
            <div class="swiper-button-prev swiper-button-prev-${index}"></div>
            <div class="swiper-button-next swiper-button-next-${index}"></div>
          </div>
          `
        );

        nextEl = container.querySelector(`.swiper-button-next-${index}`);
        prevEl = container.querySelector(`.swiper-button-prev-${index}`);

        navigation = { nextEl, prevEl };
      }
    }

    // ---------- Swiper init ----------
    const swiper = new Swiper(swiperEl, {
      modules: [Navigation, Pagination, Autoplay], // ✅ CRUCIAL
      loop,
      slidesPerView: columns,
      spaceBetween: margin,
      centeredSlides: center,
      effect,
      autoplay: autoplayEnabled ? { delay: 3000, disableOnInteraction: false } : false,
      speed: 1200,
      navigation,
      pagination,
      breakpoints: {
        1199: { slidesPerView: responsiveItems[0] },
        991: { slidesPerView: responsiveItems[1] },
        767: { slidesPerView: responsiveItems[2] },
        575: { slidesPerView: responsiveItems[3] },
        0: { slidesPerView: responsiveItems[4] },
      },
    });

    // ✅ Si boutons externes, on force init/update navigation (safe)
    if (arrows && nextEl && prevEl) {
      swiper.navigation?.init();
      swiper.navigation?.update();
    }
  });
}
